import React, { FC } from 'react';
import LeftPanel from './components/LeftPanel';
import OptForm from './components/OptForm';
import { useLocation, useNavigate } from 'react-router';
import AuthService from '@/services/AuthService';
import { toast } from 'react-toastify';

const OptPage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};

  if (!email) {
    return (
      <div className='flex flex-col md:flex-row h-screen'>
        <LeftPanel />
        <div className='w-full md:w-1/2 p-10 flex flex-col items-center justify-center'>
          <h2 className='text-3xl font-semibold mb-1'>OPT</h2>
          <p className='text-sm text-black mb-6'>
            No email provided. Please go back and enter your email.
          </p>
        </div>
      </div>
    );
  }

  const handleOtpSubmit = async (otp: string) => {
    console.log('Submitted OTP:', otp);
    const result = await AuthService.verifyOTP(email, otp);
    if (result.success) {
      navigate('/reset-password', { state: { email, otp } });
    } else {
      console.log('OTP verification failed:', result.message);
    }
  };

  const handleResend = async () => {
    await AuthService.forgotPassword(email);
    toast.success('OTP resent to your email');
  };

  return (
    <div className='flex flex-col md:flex-row h-screen'>
      <LeftPanel />

      <div className='w-full md:w-1/2 p-10 flex flex-col items-center justify-center'>
        <h2 className='text-3xl font-semibold mb-1'>OPT</h2>
        <p className='text-sm text-black mb-6'>
          Please enter OPT you got on your email
        </p>
        <OptForm onSubmit={handleOtpSubmit} onResend={handleResend} />
      </div>
    </div>
  );
};

export default OptPage;
